import React, {useState, useEffect} from 'react';
import moment from "moment";
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import {Button, MenuItem, Select, Pagination } from "@mui/material";
import {useLocation} from "react-router-dom";
import NewsList from "../../components/common/NewsList";
import {getIndustryRealtimeNewsAPI, getNewsCnt, getRealtimeNewsAPI} from "../../apis/news_service";
import NoData from "../error/NoData";
import Loading from "../error/Loading";

const NewsPage = () => {

    const [pathname] = useState(window.location.pathname.split('/'))

    const today = moment();
    const location = useLocation()
    const name = location.state?.title


    const [title, setTitle] = useState('')
    const [loading, setLoading] = useState(true)
    const [startDate, setStartDate] = useState(today);
    const [endDate, setEndDate] = useState(today);
    const [page, setPage] = useState(1)
    const [signal, setSignal] = useState(null)
    const [newsList, setNewsList] = useState([]);
    const [unit, setUnit] = useState('1d')
    const [lastPage, setLastPage] = useState(null)

    const params = {
        startdate: startDate.format('YYYYMMDD'),
        enddate: endDate.format('YYYYMMDD'),
        page: page,
        size:15,
    }

    const getFinalPage = () => {
        getNewsCnt(params).then(res => setLastPage( Math.ceil(res/15)))
    }

    const getNewsList = () => {
        if(window.location.pathname === '/news'){
            if(signal === '공시' ){
                params['category'] = 'dart'
            } else if(signal === '인물') {
                params['category'] = 'polistar'
            }
            else {
                params['signal'] = signal
            }
        }else {
            if(location.state.type === 'industry'){
                params['industry'] = location.state.range
                setTitle(location.state.title)
            }else if(location.state.type === 'theme'){
                params['theme'] = location.state.range
                setTitle(location.state.title)
            }else if(location.state.type === 'stock'){
                params['stockcode'] = location.state.range
                setTitle(location.state.title)
            }

            if (name.includes('양의')) {
                params['signal'] = '긍정'
            } else if (name.includes('음의')) {
                params['signal'] = '부정'
            }
        }

        if(!!params['industry'] || !!params['theme']){
            getIndustryRealtimeNewsAPI(params)
                .then(res => {
                    if (!!res) {setNewsList(res)}
                    setLoading(false)
                })
        } else {
            getFinalPage()
            getRealtimeNewsAPI(params)
                .then(res => {
                if (!!res) {
                    setNewsList(res)
                }
                setLoading(false)
            })
        }
    }


    useEffect(getNewsList, [pathname, startDate, endDate, page, signal])
    useEffect(()=>setPage(1), [pathname, startDate, endDate])


    const setFilter = (react) => {setSignal(react)}


    const pagination = (event, value) => {
        setPage(value);
    };

    //기간 선택
    const selectPeriod = (e) => {
        const period = e.target.value // 1w 1m ..
        const num = period.slice(0, 1) //1,3,6
        const unit = period.slice(1) //d, w, m, y
        const newSd = today.subtract(num, unit)
        setStartDate(newSd)
        setUnit(period)
    }


    return (
        <div>
            <div className='news inner_container'>
                <p className='title_sm'>{title} 뉴스</p>
                <div className='flex_layout'>
                    <div className='date_picker_container'>
                        <DatePicker className='date_picker'
                                    value={startDate}
                                    onChange={(newValue) => {
                                        setStartDate(newValue)
                                    }}
                                    maxDate={today}/>
                        <DatePicker className='date_picker'
                                    value={endDate}
                                    onChange={(newValue) => setEndDate(newValue)}
                                    minDate={startDate} maxDate={today}/>
                        <Select className='date_picker' id="demo-simple-select"
                                value={unit}
                                onChange={selectPeriod}>
                            <MenuItem value='1d'>1D</MenuItem>
                            <MenuItem value='1w'>1W</MenuItem>
                            <MenuItem value='1M'>1M</MenuItem>
                            <MenuItem value='3M'>3M</MenuItem>
                            <MenuItem value='6M'>6M</MenuItem>
                            <MenuItem value='1y'>1Y</MenuItem>
                        </Select>
                    </div>
                    <div className='btn_container' style={{display: !!name ? 'none' : ''}}>
                        <Button className={`news_btn ${signal === null ? 'click' : ''}`} onClick={() => setFilter(null)}>전체</Button>
                        <Button className={`news_btn ${signal === '긍정' ? 'click' : ''}`} onClick={() => setFilter('긍정')}>긍정</Button>
                        <Button className={`news_btn ${signal === '부정' ? 'click' : ''}`} onClick={() => setFilter('부정')}>부정</Button>
                        <Button className={`news_btn ${signal === '중립' ? 'click' : ''}`} onClick={() => setFilter('중립')}>중립</Button>
                        <Button className={`news_btn ${signal === '공시' ? 'click' : ''}`} onClick={() => setFilter('공시')}>공시</Button>
                        <Button className={`news_btn ${signal === '인물' ? 'click' : ''}`} onClick={() => setFilter('인물')}>인물</Button>
                    </div>
                </div>
                {
                    loading ?
                        <Loading/> :
                        newsList.length === 0 ?
                            <NoData/> :
                            <>
                                <div className='newslist_container'>
                                    <NewsList newsList={newsList} type='vertical' size='15' main=''/>
                                </div>
                                <div className='pagination'>
                                    <Pagination count={lastPage} shape="rounded"  onChange={pagination} sx={{".MuiPagination-ul": {justifyContent:'center'}}}/>
                                </div>
                            </>
                }
            </div>
        </div>

    );
};

export default NewsPage;
